import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
} from "@mui/material";

const team = [
  { name: "Narendra Kumar", role: "Environmental, Water & Sustainability Specialist", info: "20+ yrs experience in strategic water resource management." },
  { name: "Dr. Kareemulla Shaik ", role: "Hydrogeology Specialist", info: "16 yrs in groundwater, VES surveys & recharge." },
  { name: "Dr. Keerthan L", role: "Hydrogeologist & Geochemist", info: "Expert in groundwater modelling & geophysical surveys." },
  { name: "Dr. Kiran Kumar KM", role: "Hydrogeology Specialist", info: "9 yrs in watershed modelling & source vulnerability." },
  { name: "Suma N", role: "Social Specialist", info: "14 yrs in social assessments & CSR advisory." },
  { name: "Suresh Varma K", role: "Environmental & Regulatory Specialist", info: "10 yrs in EIA/EMP & treatment compliance." },
  { name: "Chakravarthi Karra", role: "GIS Specialist", info: "15 yrs in GIS mapping & watershed modelling." },
  { name: "Rajesh Thogaru", role: "Geology Specialist", info: "11 yrs in geological & geophysical investigations." },
  { name: "Setagopam Haritha", role: "Environmental QA/QC", info: "3 yrs in water quality & hygiene assessments." },
];

export default function GBTeam() {
  return (
    <Box sx={{ position: "relative", overflow: "hidden" }}>
      
      {/* Top Wave SVG */}
      <Box
        component="div"
        sx={{
          position: "absolute",
          top: 0,
          width: "100%",
          height: 120,
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='1440' height='120' viewBox='0 0 1440 320' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23e0f7fa' fill-opacity='1' d='M0,96L80,101.3C160,107,320,117,480,106.7C640,96,800,64,960,69.3C1120,75,1280,117,1360,138.7L1440,160V0H0Z'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      />

      {/* Section Background */}
      <Box
        sx={{
          pt: 14,
          pb: 10,
          background: "linear-gradient(180deg, #e0f7fa 0%, #f7f5f3 55%, #ffffff 100%)",
        }}
      >
        <Container maxWidth="md" sx={{ textAlign: "center", mb: 6 }}>
          <Typography variant="h4" fontWeight={800} mb={1}>
            Meet the Team
          </Typography>

          <Box
            sx={{
              width: 60,
              height: 4,
              background: "#26a69a",
              borderRadius: 2,
              mx: "auto",
              mb: 2,
            }}
          />

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ maxWidth: 600, mx: "auto" }}
          >
            Team spirit starts with spirited humans. We believe great work begins with
            happy people and ends with happy clients.
          </Typography>
        </Container>

        {/* Content Container Card */}
        <Container
          maxWidth="lg"
          sx={{
            p: 4,
            borderRadius: 4,
            background: "rgba(255, 255, 255, 0.6)",
            boxShadow: "0 8px 24px rgba(0,0,0,0.05)",
            backdropFilter: "blur(8px)",
          }}
        >
          <Grid container spacing={4} justifyContent="center">
            {team.map((member, i) => (
              <Grid item xs={12} sm={6} md={3} key={i} sx={{ textAlign: "center" }}>
                <Card
                  elevation={0}
                  sx={{
                    py: 3,
                    px: 2,
                    background: "transparent",
                    borderRadius: 3,
                    transition: "0.3s",
                    "&:hover": {
                      transform: "translateY(-6px)",
                    },
                  }}
                >
                  <Avatar
                    sx={{
                      width: 110,
                      height: 110,
                      mx: "auto",
                      mb: 2,
                      borderRadius: "50%",
                      background: "#fffdf7",
                      border: "3px solid #ffcc80",
                      color: "#333",
                      fontSize: 40,
                      fontWeight: 700,
                      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    }}
                  >
                    {member.name.charAt(0)}
                  </Avatar>

                  <Typography variant="h6" fontWeight={700}>
                    {member.name}
                  </Typography>

                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    {member.role}
                  </Typography>

                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      display: "block",
                      mt: 1,
                      opacity: 0.8,
                      fontSize: "0.78rem",
                    }}
                  >
                    {member.info}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Bottom Wave */}
      <Box
        sx={{
          width: "100%",
          height: 120,
          mt: -2,
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='1440' height='120' viewBox='0 0 1440 320' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23ffffff' d='M0,224L60,229.3C120,235,240,245,360,240C480,235,600,213,720,208C840,203,960,213,1080,202.7C1200,192,1320,160,1380,144L1440,128V320H0Z'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      />
    </Box>
  );
}
